var feeJS = feeJS || {};
feeJS.debouncedExecFactory =
  feeJS.debounceThenExecute(feeJS.execFactory, 300);



// document ready
document.addEventListener('DOMContentLoaded', () => {
  feeJS.execFactory(feeJS.execDocReady);
  feeJS.classFactory(feeJS.classListDocReady, feeJS.classParams);
  feeJS.listenerFactory(feeJS.listenerParams);
});



// document rendered
window.addEventListener('load', () => {
  feeJS.execFactory(feeJS.execOnLoad);
  feeJS.classFactory(feeJS.classListOnLoad, feeJS.classParams);
});



// resize
window.addEventListener('resize', () => {
  feeJS.debouncedExecFactory(feeJS.execResize);
});